module.exports = __webpack_public_path__ + "img/frame_2.a2c89c71.png";